// Continue Reading list tidy-up (post sidebar).
//
// Handlebars renders the ingredients (up to three related-by-tag
// rows, then next/previous) but cannot dedupe across those sources
// or sort them together. This module does both — no network, just
// the rows already in the page:
//   1. dedupe rows by URL (a neighbour can also be a related post)
//   2. sort every row newest-first
//
// (Random picks were tried and shelved: every client-side source of
// randomness needs the full post list per view. See task #15.)

export default function continueReading() {
    const list = document.querySelector(".gh-crow-list");
    if (!list) return;

    const rows = Array.from(list.querySelectorAll(".gh-crow"));

    const seen = new Set([window.location.href]);
    rows.forEach((row) => {
        const link = row.querySelector("a");
        if (!link || seen.has(link.href)) {
            row.remove();
        } else {
            seen.add(link.href);
        }
    });

    Array.from(list.querySelectorAll(".gh-crow"))
        .sort(
            (a, b) =>
                new Date(b.querySelector("time").getAttribute("datetime")) -
                new Date(a.querySelector("time").getAttribute("datetime"))
        )
        .forEach((row) => list.appendChild(row));
}
